// src/utils/audioUploader.js
import axios from 'axios';

export const uploadToPresignedUrl = async (presignedUrl, file, onProgress) => {
  try {
    await axios.put(presignedUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        if (onProgress) onProgress(percentCompleted);
      },
    });
    return true;
  } catch (error) {
    console.error('Upload failed:', error);
    return false;
  }
};